import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Menu from "../pages/menu/page";
import Nosotros from "../pages/nosotros/page";
import Causas from "../pages/causas/page";
import Blog from "../pages/blog/page";
import BlogDetail from "../pages/blog/detail/page";
import Contacto from "../pages/contacto/page";
import AdminLogin from "../pages/admin/login/page";
import AdminGuard from "../pages/admin/components/AdminGuard";
import AdminLayout from "../pages/admin/components/AdminLayout";
import AdminDashboard from "../pages/admin/dashboard/page";
import AdminProductos from "../pages/admin/productos/page";
import AdminPromociones from "../pages/admin/promociones/page";
import AdminBlog from "../pages/admin/blog/page";
import AdminFavoritos from "../pages/admin/favoritos/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/menu",
    element: <Menu />,
  },
  {
    path: "/nosotros",
    element: <Nosotros />,
  },
  {
    path: "/causas",
    element: <Causas />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/:id",
    element: <BlogDetail />,
  },
  {
    path: "/contacto",
    element: <Contacto />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: (
      <AdminGuard>
        <AdminLayout>
          <AdminDashboard />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/admin/productos",
    element: (
      <AdminGuard>
        <AdminLayout>
          <AdminProductos />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/admin/promociones",
    element: (
      <AdminGuard>
        <AdminLayout>
          <AdminPromociones />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/admin/blog",
    element: (
      <AdminGuard>
        <AdminLayout>
          <AdminBlog />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "/admin/favoritos",
    element: (
      <AdminGuard>
        <AdminLayout>
          <AdminFavoritos />
        </AdminLayout>
      </AdminGuard>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
